import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useGlobalContext } from "../../hooks/context";
import useTimeCount from "../../hooks/useTimeCount";

const RouteCheck = () => {
  const time = useTimeCount();
  const { emptySelectedItems } = useGlobalContext();

  if (time === 120) {
    emptySelectedItems();
  }

  return time === 120 ? <Navigate to="/advertise" /> : <Outlet />;
};

export default RouteCheck;
